import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import { Box, styled, Typography } from '@mui/material';
import { getStageByRate } from 'src/api/Admin';
import { useEffect, useState } from 'react';
import Stage_By_RateDetail from './Stage_By_RateDetail';

const ChartWrapper = styled('div')(({theme})=>({
  display:'flex',
  flexDirection:'column',

  position:'relative',
  height:'calc(100vh - 202px)',
}))

const ChartContainer = styled('div')(({theme})=>({
  flex:1,
  position:'relative'
}))

const LegendWrapper = styled('div')(({theme})=>({
  position : 'absolute',
  top : 60,
  right:70,
  zIndex:1
}))

const legendPayload = [
  { value: '2024', color: '#15736B' },
  { value: '2025', color: '#1CC095' },
];

const CustomLegend = ({ payload }: { payload: typeof legendPayload }) => (
  <Box display="flex" gap={2}>
    {payload.map((entry, index) => (
      <Box key={index} display="flex" alignItems="center" gap={1}>
        <Box width={12} height={12} bgcolor={entry.color} borderRadius={'100%'} />
        <Typography variant="body2" color="text.secondary" fontSize={13}>
          {entry.value}
        </Typography>
      </Box>
    ))}
  </Box>
); 

const CustomTick = ({
  x,
  y,
  payload,
}: {
  x: number
  y: number
  payload: { value: string }
}) => {
  const tickWidth = 410 / 3 // ✅ 핵심 계산
  return (
    <g transform={`translate(${x}, ${y})`}>
      <foreignObject x={-tickWidth/2} y={30} width={tickWidth} height={40}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '2px solid #96B9C4',
            padding: '12px',
            width: '100%',
            fontSize: '16px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            borderRadius: '5px',
            maxHeight: '40px',
            backgroundColor: 'white',
          }}
        >
          {payload.value}
        </div>
      </foreignObject>
    </g>
  );
};

// const groupedData = [
//     { category: '참여', pastYear: 100, CurrentYear: 100, count: 60000 },
//     { category: '관심', pastYear: 58.8, CurrentYear: 63.6, count: 8000 },
//     { category: '지원준비', pastYear: 40.0, CurrentYear: 40.9, count: 1200 },
//     { category: '지원완료', pastYear: 29.1, CurrentYear: 30.0, count: 600 },
//     { category: '임관', pastYear: 15.0, CurrentYear: 16.4, count: 11 },
// ];

export interface DataType {
  category: string;
  LastYear: number;
  CurrentYear: number;
  CurrentCount: number;
}

const Stage_By_Rate = () => {
  const [data,setData] = useState<DataType[]>([])
  useEffect(()=>{
      const fetchData = async () => {
          const response = await getStageByRate();
          setData(response.data);
      };
      
      fetchData();
  },[])

  return (
    <ChartWrapper>
      <Stage_By_RateDetail propsdata={data}/>
      <ChartContainer>
      {/* ✅ 차트 위에 겹치는 Legend */}
      <LegendWrapper>
          <CustomLegend payload={legendPayload} />
      </LegendWrapper>
      <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{top:50,right:20,bottom:90,left:-10,}}>
          <CartesianGrid/>
          <XAxis dataKey="category" axisLine={false} tickLine={false} tick={(props) => <CustomTick {...props}/>}  padding={{ left: 90, right: 89 }}/>
          <YAxis domain={[0, 100]} tickLine={false} axisLine={{stroke:'#CCCCCC'}} yAxisId="left" orientation="left" tickFormatter={(v) => `${v}`}
          ticks={[20, 40, 60, 80]} fontSize={'13px'} color='#8A8A8A'/>
          <Tooltip formatter={(v: number) => `${v.toFixed(1)}%`} />
          {/* <YAxis yAxisId="right" orientation="right" tick={false} axisLine={{stroke:'#CCCCCC'}}/> */}
          <Line dataKey="LastYear" type="linear" stroke="#15736B" 
          dot={({ cx, cy, stroke, payload, index }) => (
              <circle
                cx={cx}
                cy={cy}
                r={6}
                fill="#15736B"
                // stroke="#ffffff"
                strokeWidth={2}
              />
            )} activeDot={{ r: 8 }} yAxisId="left" strokeWidth={3}
            label={({ x, y, value }) => {
              const isLeft = value === 0;
              return(
              <text
                x={x - 10}      // 🔹 왼쪽으로 10px 이동
                y={isLeft ? y + 4 :y + 14}       // 🔹 수직 정렬 보정
                textAnchor="end"
                fill="#15736B"
                fontSize="12px"
              >
                {value}%
              </text>
            )}}>
              {/* <LabelList content={CustomBarLabel("2023", "#8A8A8A")} /> */}
          </Line>
          <Line dataKey="CurrentYear" type="linear" stroke="#1CC095" 
          dot={({ cx, cy, stroke, payload, index }) => (
              <circle
                cx={cx}
                cy={cy}
                r={6}
                fill="#1CC095"
                // stroke="#ffffff"
                strokeWidth={2}
              />
            )} activeDot={{ r: 8 }} yAxisId="left" strokeWidth={3}
            label={({ x, y, value }) => {
              const isRight = value === 100;
              return(
              <text
                x={x + 10}      // 🔹 오른쪽으로 10px 이동
                y={isRight ? y + 4 : y - 14}       // 🔹 수직 정렬 보정
                textAnchor="start"
                fill="#1CC095"
                fontSize="12px"
              >
                {value}%
              </text>
            )}}>
              {/* <LabelList content={CustomBarLabel("2024", "#8A8A8A")} /> */}
          </Line>
          </LineChart> 
      </ResponsiveContainer>
      </ChartContainer>
    </ChartWrapper>
  )
}

export default Stage_By_Rate